var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"custom-footer"}},[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container",class:_vm.getFooterWidth()},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"align-text-bottom"},[_vm._v("\n          Haohaotiantian\n"),_c('a',{staticClass:"fa fa-github social-icons pl-2",attrs:{"href":"https://github.com/em-shea/vocab"}})])
}]

export { render, staticRenderFns }